import * as notionParser from "./notion-to-md";
import { Client } from "@notionhq/client";


export interface Config {
    apiKey: string;
    pageId: string;
}

export interface MarkDownData {
    title: string;
    description: string;
    content: string;
    heroImage?: string;
    tags?: string[];
}
function extractTitleDescriptionAndHeroImage(markdown:string) {
    const lines = markdown.split('\n');

    let title = '';
    let description = '';
    let heroImage = '';

    // Extract Title
    for (let line of lines) {
        if (line.startsWith('# ')) { // h1
            title = line.replace('# ', '').trim();
            break;
        } else if (line.startsWith('## ')) { // h2
            title = line.replace('## ', '').trim();
            break;
        } else if (line.startsWith('### ')) { // h2
            title = line.replace('###', '').trim();
            break;
        } else if (line.startsWith('#### ')) { // h2
            title = line.replace('#### ', '').trim();
            break;
        } else if (line.startsWith('##### ')) { // h2
            title = line.replace('##### ', '').trim();
            break;
        } else if (line.startsWith('###### ')) { // h2
            title = line.replace('###### ', '').trim();
            break;
        } // 
    }

    // Extract Hero Image
    for (let line of lines) {
        if (line.startsWith('![')) { 
            // Regex to extract URL between parenthesis
            const regex = /\((.*?)\)/;
            const matches = regex.exec(line);
            if (matches) {
                heroImage = matches[1];
                break;
            }
        }
    }

    // Extract Description
    let startIndex = lines.indexOf(title) + 1;
    let endIndex = lines.length;
    for (let i = startIndex; i < lines.length; i++) {
        if (lines[i].startsWith('#') || lines[i].startsWith('![')) { // Check for any header or image
            endIndex = i;
            break;
        }
    }

    let descriptionLines = lines.slice(startIndex, endIndex)
        .filter(line => !line.startsWith('![') && line.trim() !== ''); // Filtering out image lines and empty lines
    let descriptionContent = descriptionLines.join(' ');
    let maxLength = 155; // Google's recommended maximum length for meta descriptions
    if (descriptionContent.length > maxLength) {
        descriptionContent = descriptionContent.substring(0, maxLength);
        description = descriptionContent.substring(0, descriptionContent.lastIndexOf('. ') + 1).trim();
    } else {
        description = descriptionContent.trim();
    }

    return {
        title,
        description,
        heroImage
    };
}
export async function notionHtmlParser(config: Config): Promise<MarkDownData> {
    if (!config.apiKey || !config.pageId || config.apiKey.length < 10 || config.pageId.length < 10) {
        throw new Error("apiKey or pageId is not defined");
    }

    const notionClient = new Client({
        auth: config.apiKey,
    });

    const n2m = new notionParser.NotionToMarkdown({ 
        notionClient: notionClient, 
        config: {
            parseChildPages: true,
        }
    });

    const { results } = await notionClient.blocks.children.list({
        block_id: config.pageId,
    });

    const x = await n2m.blocksToMarkdown(results);
    let markDownString = n2m.toMarkdownString(x);
    let {title, description, heroImage} = extractTitleDescriptionAndHeroImage(markDownString.parent);
    return {
        title: title,
        description: description,
        heroImage: heroImage,
        tags: [],
        content: markDownString.parent
    }
   
}